export default "__VITE_PUBLIC_ASSET__824f7d68__"